<template>
  <div class="time-sheet-details">
    <section class="details-section">
      <TimeSheetDetailsBody :time-sheet="currentTimeSheet" />
    </section>
  </div>
</template>

<script>
import TimeSheetDetailsBody from './components/TimeSheetDetailsBody';
import { TimeSheetDetailsActions } from './time-sheet-details.keys';
import { AppActions } from '@/app/app.keys';

export default {
  name: 'TimeSheetDetails',
  components: {
    TimeSheetDetailsBody
  },
  computed: {
    currentTimeSheet() {
      return this.$store.state.timeSheetsState.timeSheetDetailsState.currentTimeSheet;
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(val) {
        this.$store.dispatch(TimeSheetDetailsActions.RetrieveTimeSheet, val.params.id);
      }
    }
  },
  destroyed() {
    this.$store.dispatch(TimeSheetDetailsActions.ResetCurrentTimeSheet);
  },
  mounted() {
    this.$store.dispatch(AppActions.SetPageTitle, this.$t('timeSheets.details.timeSheet'));
    this.$store.dispatch(TimeSheetDetailsActions.RetrieveTimeSheet, this.$route.params.id);
  }
};
</script>

<style lang="scss" scoped>
@import '../../../../styles/colors.scss';
@import '../../../../styles/variables.scss';

@media print {
  .time-sheet-details .details-section {
    margin: 0;
  }
}
</style>
